import { render, staticRenderFns } from "./SchemeIcon.vue?vue&type=template&id=62dd51c5&scoped=true"
import script from "./SchemeIcon.vue?vue&type=script&lang=js"
export * from "./SchemeIcon.vue?vue&type=script&lang=js"
import style0 from "./SchemeIcon.vue?vue&type=style&index=0&id=62dd51c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd51c5",
  null
  
)

export default component.exports